import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCodal = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={29}
    height={19}
    fill='currentColor'
    stroke={'2'}
    {...props}
  >
    <path
      fillRule='evenodd'
      stroke='currentColor'
      strokeMiterlimit={10}
      strokeWidth={0.5}
      d='M23.823 7.154h4.345v2.113h-4.466c-.543 0-1.026.482-1.026 1.026v.422c0 .543.483 1.026 1.026 1.026h2.5949999999999998c1.388 0 2.595 1.147 2.595 2.595v1.57c0 1.387-1.147 2.594-2.595 2.594h-5.25a2.65 2.65 0 0 1-1.872-.784 2.65 2.65 0 0 1-1.87.784H11.63v-2.172h5.794c.543 0 1.026-.483 1.026-1.026v-1.69c0-.543-.483-1.026-1.026-1.026h-1.63v-2.052h1.45c1.387 0 2.594 1.147 2.594 2.595v2.535c.12.422.543.784.966.784h5.552c.543 0 1.026-.482 1.026-1.026V15c0-.543-.483-1.026-1.026-1.026h-2.5340000000000003c-1.389 0-2.596-1.147-2.596-2.595v-1.57c.06-1.508 1.207-2.655 2.596-2.655ZM9.58.515v15.39c0 1.388-1.147 2.595-2.596 2.595H3.001c-1.388 0-2.595-1.147-2.595-2.596V11.5h2.172v3.862c0 .543.423.966.966.966h2.897a.953.953 0 0 0 .966-.966V.515z'
      clipRule='evenodd'
    />
    <path
      stroke='currentColor'
      strokeMiterlimit={10}
      strokeWidth={0.5}
      d='M13.804.515H11.69v13.579h2.113z'
    />
    <path
      fillRule='evenodd'
      stroke='currentColor'
      strokeMiterlimit={10}
      strokeWidth={0.5}
      d='M27.745.998c-.664-.664-1.69-.664-2.293 0-.664.664-.664 1.69 0 2.293.12.121.241.181.362.242l-1.57 1.63.785.844 2.716-2.716c.604-.603.604-1.63 0-2.293Z'
      clipRule='evenodd'
    />
  </svg>
);
export default SvgCodal;
